import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Package, ShoppingCart, Users, MessageSquare, HelpCircle, Image as ImageIcon, Tag, LogOut, Wallet } from "lucide-react";

const links = [
  { to: "/admincontrol", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admincontrol/products", label: "Products", icon: Package },
  { to: "/admincontrol/categories", label: "Categories", icon: Tag },
  { to: "/admincontrol/orders", label: "Orders", icon: ShoppingCart },
  { to: "/admincontrol/customers", label: "Customers", icon: Users },
  { to: "/admincontrol/settings", label: "UPI Payments", icon: Wallet },
  { to: "/admincontrol/testimonials", label: "Testimonials", icon: MessageSquare },
  { to: "/admincontrol/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admincontrol/banners", label: "Banners", icon: ImageIcon },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) nav("/login");
  }, [user, loading, nav]);

  if (loading || !user) return <div className="min-h-[60vh] grid place-items-center text-kyro-mute">Loading admin...</div>;

  return (
    <div className="min-h-screen bg-[#08090b]">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-8">
        <div className="grid lg:grid-cols-[240px_1fr] gap-6">
          <aside className="hidden lg:block">
            <div className="kyro-glass rounded-2xl p-3 sticky top-24">
              <div className="px-3 py-3">
                <div className="kyro-overline">Admin</div>
                <p className="font-display font-bold text-lg mt-1">Baba Media Console</p>
              </div>
              <nav className="mt-2 space-y-1">
                {links.map((l) => {
                  const Icon = l.icon;
                  return (
                    <NavLink
                      key={l.to}
                      to={l.to}
                      end={l.end}
                      data-testid={`admin-nav-${l.label.toLowerCase()}`}
                      className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-[#FF4433] text-white" : "text-kyro-mute hover:bg-white/5 hover:text-kyro-ink"}`}
                    >
                      <Icon className="w-4 h-4" /> {l.label}
                    </NavLink>
                  );
                })}
              </nav>
              <div className="mt-3 pt-3 border-t border-white/5 px-3">
                <button onClick={async () => { await logout(); nav("/"); }} className="text-sm text-kyro-mute hover:text-[#FF4433] flex items-center gap-2"><LogOut className="w-4 h-4" /> Sign out</button>
              </div>
            </div>
          </aside>
          <main>
            {/* Mobile nav */}
            <div className="lg:hidden mb-6 flex gap-2 overflow-x-auto pb-2">
              {links.map((l) => (
                <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `shrink-0 px-3 py-1.5 rounded-full text-xs ${isActive ? "bg-[#FF4433] text-white" : "border border-white/10 text-kyro-mute"}`}>{l.label}</NavLink>
              ))}
            </div>
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
